/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataWarehouseResVo } from './PageDataWarehouseResVo';
import {
    PageDataWarehouseResVoFromJSON,
    PageDataWarehouseResVoFromJSONTyped,
    PageDataWarehouseResVoToJSON,
    PageDataWarehouseResVoToJSONTyped,
} from './PageDataWarehouseResVo';

/**
 * 
 * @export
 * @interface ResponsePageDataWarehouseResVo
 */
export interface ResponsePageDataWarehouseResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataWarehouseResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataWarehouseResVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataWarehouseResVo}
     * @memberof ResponsePageDataWarehouseResVo
     */
    data?: PageDataWarehouseResVo;
}

/**
 * Check if a given object implements the ResponsePageDataWarehouseResVo interface.
 */
export function instanceOfResponsePageDataWarehouseResVo(value: object): value is ResponsePageDataWarehouseResVo {
    return true;
}

export function ResponsePageDataWarehouseResVoFromJSON(json: any): ResponsePageDataWarehouseResVo {
    return ResponsePageDataWarehouseResVoFromJSONTyped(json, false);
}

export function ResponsePageDataWarehouseResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataWarehouseResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataWarehouseResVoFromJSON(json['data']),
    };
}

export function ResponsePageDataWarehouseResVoToJSON(json: any): ResponsePageDataWarehouseResVo {
    return ResponsePageDataWarehouseResVoToJSONTyped(json, false);
}

export function ResponsePageDataWarehouseResVoToJSONTyped(value?: ResponsePageDataWarehouseResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataWarehouseResVoToJSON(value['data']),
    };
}

